import { Pipe, PipeTransform } from '@angular/core';
import { Helper } from '../classes';

@Pipe({
    name: 'productWarrantType',
    pure: false
})
export class ProductWarrantTypePipe implements PipeTransform {
    transform(type: number): string {
        return Helper.textsHelper().getProductWarrantTypeName(type);
    }
}
